/* eslint-disable */
import { call, put, takeLatest, select } from "redux-saga/effects";
import { selectors as sessionSelectors } from "reducers/session";
import * as accountsMiddleware from "middleware/accounts";
import { types } from "reducers/checks";
import { store } from "store";

const sagas = [
    takeLatest(types.CHECKBOOK_CREDENTIAL_REQUEST, listCredentialsGroups),
    takeLatest(types.CHECKBOOK_TICKET_REQUEST, ticketRequest),
];

export default sagas;

function* listCredentialsGroups() {
    const { userId: idUser } = sessionSelectors.getUser(store.getState());
    const params = { idUser, active: true, idActivityToRead: "request.accountsCheckbook.send" };
    const response = yield call(accountsMiddleware.listCredentialsGroups, params);
    if (response && response.status === 200) {
        yield put({
            type: types.CHECKBOOK_CREDENTIAL_SUCCESS,
            newCheckbookRequiredCredentials: response.data.data?.groups[0]?.credentials,
        });
    }
}

function* ticketRequest({ newCheckbookData }) {
    const { userId: idUser } = sessionSelectors.getUser(store.getState());
    const params = { idUser, active: true, ...newCheckbookData };
    const response = yield call(accountsMiddleware.accountCheckbookRequest, params);

    if (response && response.status === 200) {
        const ticketStates = {
            COR020W: "INVALID_CREDENTIAL",
            API515I: "AWAITING_BACKOFFICE_SIGNATURE",
            COR023I: "PENDING_USER_SIGNATURES",
        };

        yield put({
            type: types.CHECKBOOK_TICKET_SUCCESS,
            newCheckbookTicket: {
                status: ticketStates[response.data.code],
                ...response.data,
            },
        });
    }
}
